import { initLanguage } from "./i18n";

// The language is settled BEFORE any of the app's modules load: the menu tree, column lists and
// option lists compute their labels at import time, and must compute them in the reader's language.
void initLanguage()
  .catch((e) => console.error("Could not load the language bundle:", e))
  .then(() => import("./boot"))
  .then(({ default: bootstrap }) => bootstrap());
